import { regex } from '../../node_modules/vuelidate/lib/validators/common'
export default regex('colorcode', /^#([0-9A-Fa-f]{6}|[0-9A-Fa-f]{3}$)/)



// WEBPACK FOOTER //
// ./src/validators/colorcode.js